'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';

/**
 * Importación de las Actions.
 */
import {
    GET_SCREEN_DATA_PERFYPERM_STARTS,
    SET_USER_FUNCTIONS_PERFYPERM,
    GET_SCREEN_DATA_PERFYPERM_SUCCESS,
    RESET_STATE_PERFYPERM,
    SELECT_PRODUCTO_PERFYPERM,
    SELECT_CATEGORIA_PERFYPERM,
    SELECT_PROGRAMA_PERFYPERM,
    SET_PERFIL_EDICION,
    SET_PERFIL_SELECCIONADO,
    ELIMINACION_PERFIL_SUCCESS,
    SET_SAVE_ERROR_MSG_PERFYPERM,
    CREATE_PERFIL_RESULT,
    LIMPIAR_MENSAJES_PERFYPERM,
    SET_EDIT_ERROR_MSG_PERFYPERM,
    EDIT_PERFIL_RESULT,
    ESCONDER_POPUP_PERFYPERM,
    SELECT_GRUPO_WINDOWS_PERFILES_Y_PERMISOS,
    DESELECT_GRUPO_WINDOWS_PERFILES_Y_PERMISOS,
    SELECT_GRUPO_WINDOWS_PERFILES_Y_PERMISOS_EDIT,
    DESELECT_GRUPO_WINDOWS_PERFILES_Y_PERMISOS_EDIT,
    STOP_CLEAR_POP_UP_DATA_PERFYPERM,
    START_CLEAR_POP_UP_DATA_PERFYPERM,
    SET_POP_UP_PERFYPERM,
    BUSCAR_PERFIL
} from '../../Screens/PerfilesyPermisos/actions/PerfilesyPermisos';

/**
 * Estado inicial.
 */
const initialState = {
    isFetching: false,

    //Funciones de seguridad
    functions: [],

    perfiles: [],
    perfilesOriginales:[],
    productos: [],
    categorias: [],
    programas: [],
    profileSelected: {
        id: 0,
        userCount: 0,
        descripcion: "",
        functionalities: [],
        products: []
    },

    //Filtro de combos
    filter: {
        product: 0,
        category: 0,
        program: 0,
        activate: false
    },

    //Mensajes y pop up
    saveErrorMessage: "",
    saveDescripcionErrorMessage: "",
    editErrorMessage: "",
    editErrorMessageDescripcion: "",

    gruposWindows: [],
    configuracionSesion: {},

    message: "",
    messageClass: "",
    messageHidden: true,

    clearFlag: false
};

/**
 * Variables globales del reducer
 */
let result, perfiles, perfilesOriginales;

/**
 * 
 * @param {any} state
 * @param {any} action
 */
function perfilesyPermisos(state = initialState, action) {

    function ordenarPerfilesAlfabeticamente(arrayPerfiles){
        if(arrayPerfiles != undefined && arrayPerfiles.length > 0)
        {
            arrayPerfiles = arrayPerfiles.sort(function (a, b) {
                if (a.Codigo.toLowerCase() > b.Codigo.toLowerCase()) {
                    a.first = false;
                    b.first = false;
                    return 1;
                }
                if (a.Codigo.toLowerCase() < b.Codigo.toLowerCase()) {
                    a.first = false;
                    b.first = false;
                    return -1;
                }
                return 0;
            });
            arrayPerfiles[0].first = true;
        }
        return arrayPerfiles;
    }

    switch (action.type) {
        case GET_SCREEN_DATA_PERFYPERM_STARTS:
            LogHelper.In(perfilesyPermisos.name, action, state);

            result = {
                ...state,
                isFetching: true
            };
            break;

        case SET_USER_FUNCTIONS_PERFYPERM:
            LogHelper.In(perfilesyPermisos.name, action, state);

            result = {
                ...state,
                functions: action.functions
            };
            break;

        case BUSCAR_PERFIL:

            if (action.palabra.length == 0) {
                result = {
                    ...state,
                    perfiles: state.perfilesOriginales
                };
            } else {
                var found = state.perfilesOriginales.filter(function (element) { return element.Codigo.toUpperCase().includes(action.palabra) });
                result = {
                    ...state,
                    perfiles: found
                };
            }
            break;

        case GET_SCREEN_DATA_PERFYPERM_SUCCESS:
            LogHelper.In(perfilesyPermisos.name, action, state);
            action.result.GET_PERFILES = ordenarPerfilesAlfabeticamente(action.result.GET_PERFILES);            
            result = {
                ...state,
                productos: action.result.GET_PRODUCTOS,
                categorias: action.result.GET_CATEGORIAS,
                programas: action.result.GET_PROGRAMAS,
                perfiles: action.result.GET_PERFILES,
                perfilesOriginales: action.result.GET_PERFILES,
                isFetching: false,
                configuracionSesion: action.result.GET_CONFIGURATION_PASSWORD_TYPE,
                gruposWindows: action.result.GET_GRUPOS_WINDOWS
            };
            break;

        case RESET_STATE_PERFYPERM:
            LogHelper.In(perfilesyPermisos.name, action, state);

            result = initialState;
            break;

        case SELECT_PRODUCTO_PERFYPERM:
            LogHelper.In(perfilesyPermisos.name, action, state);

            perfiles = JSON.parse(JSON.stringify(state.perfiles));
            perfilesOriginales = JSON.parse(JSON.stringify(state.perfilesOriginales));
            
            perfiles = ordenarPerfilesAlfabeticamente(perfiles);
            perfilesOriginales = ordenarPerfilesAlfabeticamente(perfilesOriginales);

            perfiles.forEach(function (perfil) {
                perfil.functions = [];
            });

            perfilesOriginales.forEach(function (perfil) {
                perfil.functions = [];
            });

            result = {
                ...state,
                perfiles: perfiles,
                perfilesOriginales: perfilesOriginales,
                filter: {
                    product: parseInt(action.id),
                    category: 0,
                    program: 0,
                    activate: false
                }
            };
            break;

        case SELECT_CATEGORIA_PERFYPERM:
            LogHelper.In(perfilesyPermisos.name, action, state);

            perfiles = JSON.parse(JSON.stringify(state.perfiles));
            perfilesOriginales = JSON.parse(JSON.stringify(state.perfilesOriginales));
            
            perfiles = ordenarPerfilesAlfabeticamente(perfiles);
            perfilesOriginales = ordenarPerfilesAlfabeticamente(perfilesOriginales);

            perfiles.forEach(function (perfil) {
                perfil.functions = [];
            });

            perfilesOriginales.forEach(function (perfil) {
                perfil.functions = [];
            });

            result = {
                ...state,
                perfiles: perfiles,
                perfilesOriginales: perfilesOriginales,
                filter: {
                    product: state.filter.product,
                    category: parseInt(action.id),
                    program: 0,
                    activate: false
                }
            };
            break;

        case SELECT_PROGRAMA_PERFYPERM:
            LogHelper.In(perfilesyPermisos.name, action, state);

            perfiles = JSON.parse(JSON.stringify(state.perfiles));
            perfilesOriginales = JSON.parse(JSON.stringify(state.perfilesOriginales));

            perfiles = ordenarPerfilesAlfabeticamente(perfiles);
            perfilesOriginales = ordenarPerfilesAlfabeticamente(perfilesOriginales);

            perfiles.forEach(function (perfil) {
                perfil.functions = action.funcionalidades.filter(x => x.PerfilId == perfil.Id);
            });

            perfilesOriginales.forEach(function (perfil) {
                perfil.functions = action.funcionalidades.filter(x => x.PerfilId == perfil.Id);
            });

            result = {
                ...state,
                perfiles: perfiles,
                perfilesOriginales: perfilesOriginales,
                filter: {
                    product: state.filter.product,
                    category: state.filter.category,
                    program: parseInt(action.id),
                    activate: true
                }
            };
            break;

        case SET_PERFIL_EDICION:
            LogHelper.In(perfilesyPermisos.name, action, state);

            perfiles = JSON.parse(JSON.stringify(state.perfiles));

            perfiles = ordenarPerfilesAlfabeticamente(perfiles); 

            perfiles.forEach(function (perfil) {
                perfil.functions = [];
            });
            result = {
                ...state,
                profileSelected: {
                    id: action.id,
                    userCount: 0,
                    descripcion: state.perfiles.find(x => x.Id == action.id).Descripcion,
                    codigo: state.perfiles.find(x => x.Id == action.id).Codigo,
                    functionalities: [],
                    products: [],
                    productoId: state.perfiles.find(x => x.Id == action.id).ProductoId,
                    gruposWindows: action.gruposWindows
                },
                filter: {
                    product: 0,
                    category: 0,
                    program: 0,
                    activate: false
                },
                perfiles: perfiles

            };
            break;

        case SET_PERFIL_SELECCIONADO:
            LogHelper.In(perfilesyPermisos.name, action, state);

            result = {
                ...state,
                profileSelected: action.profileSelected
            };
            break;

           case ELIMINACION_PERFIL_SUCCESS:
            LogHelper.In(perfilesyPermisos.name, action, state);

            perfiles = JSON.parse(JSON.stringify(state.perfiles));
            perfilesOriginales = JSON.parse(JSON.stringify(state.perfilesOriginales));
            let index = perfiles.indexOf(perfiles.find(x => x.Id == state.profileSelected.id));
            let indexOriginal = perfilesOriginales.indexOf(perfilesOriginales.find(x => x.Id == state.profileSelected.id));
            perfiles.splice(index, 1);
            perfilesOriginales.splice(indexOriginal, 1);

            perfiles = ordenarPerfilesAlfabeticamente(perfiles); 
            
            result = {
                ...state,
                isFetching: false,
                perfiles: perfiles,
                perfilesOriginales,
                message: "El perfil " + state.perfiles.find(x => x.Id == state.profileSelected.id).Codigo + " ha sido eliminado",
                messageClass: "success",
                messageHidden: false,
                profileSelected: {
                    id: 0,
                    userCount: 0,
                    descripcion: "",
                    functionalities: [],
                    products: []
                }
            };
            break;

        case SET_SAVE_ERROR_MSG_PERFYPERM:
            LogHelper.In(perfilesyPermisos.name, action, state);

            result = {
                ...state,
                saveErrorMessage: action.saveErrorMessage,
                saveDescripcionErrorMessage: action.saveDescripcionErrorMessage
            };
            break;

        case CREATE_PERFIL_RESULT:

            LogHelper.In(perfilesyPermisos.name, action, state);
            action.response.perfiles = ordenarPerfilesAlfabeticamente(action.response.perfiles); 
            result = {
                ...state,
                isFetching: false,
                perfiles: action.response.perfiles,
                perfilesOriginales: action.response.perfiles,
                clearFlag: true,
                filter: {
                    product: state.filter.product,
                    category: state.filter.category,
                    program: state.filter.program,
                    activate: action.response.activate
                },
                message: action.response.message,
                messageClass: "success",
                messageHidden: false,
                saveErrorMessage: ""
            };
            break;

        case LIMPIAR_MENSAJES_PERFYPERM:
            LogHelper.In(perfilesyPermisos.name, action, state);

            result = {
                ...state,
                saveErrorMessage: "",
                saveDescripcionErrorMessage: "",
                editErrorMessage: "",
                editErrorMessageDescripcion: ""
            };
            break;

        case SET_EDIT_ERROR_MSG_PERFYPERM:
            LogHelper.In(perfilesyPermisos.name, action, state);

            result = {
                ...state,
                editErrorMessage: action.editErrorMessage,
                editErrorMessageDescripcion: action.editErrorMessageDescripcion
            };
            break;

        case EDIT_PERFIL_RESULT:
            LogHelper.In(perfilesyPermisos.name, action, state);

            action.response.perfiles = perfiles = ordenarPerfilesAlfabeticamente(action.response.perfiles);
            result = {
                ...state,
                isFetching: false,
                perfiles: action.response.perfiles,
                filter: {
                    product: state.filter.product,
                    category: state.filter.category,
                    program: state.filter.program,
                    activate: action.response.activate
                },
                editErrorMessage: "",
                editErrorMessageDescripcion: "",
                profileSelected: {
                    id: 0,
                    userCount: 0,
                    descripcion: "",
                    functionalities: [],
                    products: []
                }
            };
            break;

        case ESCONDER_POPUP_PERFYPERM:
            LogHelper.In(perfilesyPermisos.name, action, state);

            result = {
                ...state,
                message: "",
                messageClass: "",
                messageHidden: true,
                clearFlag: false
            };
            break;

        case SELECT_GRUPO_WINDOWS_PERFILES_Y_PERMISOS:
            LogHelper.In(perfilesyPermisos.name, action, state);

            let temp = JSON.parse(JSON.stringify(state.gruposWindows));

            temp.forEach(function (group, index) {

                if (group.Id == action.id) {
                    temp[index].Selected = true;
                }
            })

            result = {
                ...state,
                gruposWindows: temp
            };

            break;

        case DESELECT_GRUPO_WINDOWS_PERFILES_Y_PERMISOS:
            LogHelper.In(perfilesyPermisos.name, action, state);

            temp = JSON.parse(JSON.stringify(state.gruposWindows));

            temp.forEach(function (group, index) {

                if (group.Id == action.id) {
                    temp[index].Selected = false;
                }
            })

            result = {
                ...state,
                gruposWindows: temp
            };

            break;

        case SELECT_GRUPO_WINDOWS_PERFILES_Y_PERMISOS_EDIT:

            let profileSelectedModify = JSON.parse(JSON.stringify(state.profileSelected));

            temp = JSON.parse(JSON.stringify(state.profileSelected.gruposWindows));

            temp.forEach(function (element, index) {
                if (element.Id == action.idGrupo)
                    temp[index].Selected = true;
            });

            profileSelectedModify.gruposWindows = temp;

            result = {
                ...state,
                profileSelected: profileSelectedModify
            };
            break;

        case DESELECT_GRUPO_WINDOWS_PERFILES_Y_PERMISOS_EDIT:

            profileSelectedModify = JSON.parse(JSON.stringify(state.profileSelected));

            temp = JSON.parse(JSON.stringify(state.profileSelected.gruposWindows));

            temp.forEach(function (element, index) {
                if (element.Id == action.idGrupo)
                    temp[index].Selected = false;
            });

            profileSelectedModify.gruposWindows = temp;

            result = {
                ...state,
                profileSelected: profileSelectedModify
            };

            break;

        case STOP_CLEAR_POP_UP_DATA_PERFYPERM:

            result = {
                ...state,
                clearFlag: false
            };

            break;

        case START_CLEAR_POP_UP_DATA_PERFYPERM:

            result = {
                ...state,
                clearFlag: true,
                saveErrorMessage: "",
                saveDescripcionErrorMessage: ""
            };

            break;

        case SET_POP_UP_PERFYPERM:
            LogHelper.In(perfilesyPermisos.name, action, state);

            result = {
                ...state,
                message: action.message.value,
                messageClass: action.message.class,
                messageHidden: false,
                isFetching: false
            };
            break;

        default:
            result = { ...state };
            break;
    }

    LogHelper.Out(perfilesyPermisos.name, result);

    return result;
}

export default perfilesyPermisos;